module.exports = __webpack_public_path__ + "static/images/styles/images/nations/usa.182fe821.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/usa.png
// module id = 3676
// module chunks = 11